import React from 'react';

import {
    FormControl,
    FormHelperText,
    ToggleButton,
    ToggleButtonGroup,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const ReactHookFormToggleButtonGroup = ({
    control,
    disabled,
    fullWidth,
    name,
    onChange,
    options,
    size = 'small',
    sx,
    sxFormControl,
}) => {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field, fieldState: { error } }) => (
                <FormControl
                    error={Boolean(error)}
                    disabled={disabled}
                    fullWidth={fullWidth}
                    size={size}
                    sx={sxFormControl}
                >
                    <ToggleButtonGroup
                        color="primary"
                        disabled={disabled}
                        fullWidth={fullWidth}
                        exclusive
                        onChange={(_, value) => {
                            if (value === null) return;
                            if (onChange) onChange(value);
                            field.onChange(value);
                        }}
                        value={field.value}
                        size={size}
                        sx={sx}
                    >
                        {options?.map((option) => (
                            <ToggleButton
                                disabled={option.disabled}
                                key={option.value}
                                value={option.value}
                            >
                                {option.label}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>

                    {Boolean(error) && (
                        <FormHelperText>{error?.message}</FormHelperText>
                    )}
                </FormControl>
            )}
        />
    );
};

ReactHookFormToggleButtonGroup.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    size: PropTypes.string,
    sx: PropTypes.object,
    sxFormControl: PropTypes.object,
};

export default ReactHookFormToggleButtonGroup;
